import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Card, Spinner, Alert } from '../components/ui';
import PostModal from '../components/PostModal/PostModal';
import Calendar from '../components/Calendar/Calendar';
import { usePostsPoll } from '../queries/onboardingPolls';

const TimeSlotsPage = () => {
  const queryClient = useQueryClient();

  // Fetch posts (which contain scheduling information)
  const {
    data: posts = [],
    isLoading,
    error,
    openModal,
    handleScheduleSuccess,
  } = usePostsPoll(true);

  const handleEventClick = (clickInfo) => {
    const post = clickInfo.event.extendedProps.post;
    openModal(post, handleScheduleSuccess);
  };

  if (isLoading) {
    return (
      <div className='space-y-6'>
        <div className='flex items-center justify-between'>
          <h1 className='text-2xl font-bold text-gray-900'>Content Calendar</h1>
        </div>
        <Card>
          <Card.Body>
            <div className='flex items-center justify-center py-20'>
              <Spinner size='lg' />
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }

  if (error) {
    return <Alert variant='error'>Failed to load schedule: {error.message}</Alert>;
  }

  return (
    <div className='h-[calc(100vh-100px)] flex flex-col gap-4'>
      <Calendar posts={posts} onEventClick={handleEventClick} />

      {/* Post Details Modal */}
      <PostModal />
    </div>
  );
};

export default TimeSlotsPage;
